import React, { useEffect } from 'react';
import { useCreateSMSKeyword } from '../../../editor/features/smsKeywords/SMSKeywordsPanel/use-create-sms-keyword';

export const CreateRemoteSMSKeyword = () => {
  const { createKeyword } = useCreateSMSKeyword();

  useEffect(() => {
    createKeyword();
  }, []);

  return <div />;
};
